import React from 'react';
import ReactMarkdown from 'react-markdown';

interface Props {
    reasonParagraph: string;
}

const ReasonParagraph = React.memo<Props>(({ reasonParagraph }) => {
    return (
        <div className="w-4/5 font-sf text-12 text-sf-gray-500 whitespace-normal">
            <ReactMarkdown>{reasonParagraph}</ReactMarkdown>
        </div>
    );
});

export default ReasonParagraph;
